module.exports = __webpack_public_path__ + "media/configurations/SX-SX-SO-87cc4703.png";